// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export class ApiResponse<TData> {
  constructor(
    public readonly status: number,
    public readonly ok: boolean,
    public readonly headers: Headers,
    private readonly dataValue: TData,
  ) {}

  unwrap(): TData {
    return this.dataValue;
  }

  map<TMapped>(mapper: (value: TData) => TMapped): ApiResponse<TMapped> {
    return new ApiResponse<TMapped>(
      this.status,
      this.ok,
      this.headers,
      mapper(this.dataValue),
    );
  }
}
